"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    envPlugin: ()=>envPlugin
});
const index_js_namespaceObject = require("../../domain-id/index.js");
const external_tool_js_namespaceObject = require("../../tool.js");
function envPlugin(envConfig) {
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig;
                var _config_url;
                const url = null != (_config_url = config.url) ? _config_url : '';
                if (/^https?:/.test(url)) return config;
                var _config_pluginConfig_domainID, _ref;
                const domainID = null != (_ref = null != (_config_pluginConfig_domainID = null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.domainID) ? _config_pluginConfig_domainID : index_js_namespaceObject.currentDomainID) ? _ref : 'online';
                const prefixUrl = (await Promise.resolve(envConfig))[domainID];
                if (!prefixUrl) throw new external_tool_js_namespaceObject.CommonLibError('EnvPlugin', `please set ${domainID} environment url in env plugin`);
                config.url = `${prefixUrl}${url}`;
                return config;
            }
        ]
    };
}
exports.envPlugin = __webpack_exports__.envPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "envPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
